import {DailyGameMocks} from '@/services/shared/DailyGameService/DailyGameService.mocks';
import {GameStatusMocks} from '@/services/shared/GameStatusService/GameStatusService.mocks';
import {LeaderBoardMocks} from '@/services/shared/LeaderBoardService/LeaderBoardService.mock';
import {TasksMocks} from '@/services/shared/TasksService/TasksService.mocks';
import {EventEmitter} from 'pixi.js';

import {token} from 'brandi';

import {NullStorage, RealStorage} from '@specials/localstorage';
import {SentryBrowserAbstract} from '@specials/sentry-browser';

import {ResourcesAll} from '@/resources';
import {ClickerIncomeUpdater} from '@/services/ClickerIncomeUpdater/ClickerIncomeUpdater';
import {CookieStorage} from '@/services/CookieStorage/CookieStorage';
import {RewardsAnimationsService} from '@/services/DailyRewardsAnimationService/RewardsAnimationsService';
import {DevToolsMbService} from '@/services/DevToolsMbService/DevToolsMbService';
import {ErrorsService} from '@/services/ErrorsService/ErrorsService';
import {LoggerService} from '@/services/LoggerService/LoggerService';
import {MediaService} from '@/services/MediaService/MediaService';
import {NavigationClickerModalService} from '@/services/NavigationClickerModalService/NavigationClickerModalService';
import {NavigationService} from '@/services/NavigationService/NavigationService';
import {PlatformService} from '@/services/PlatformService/PlatformService';
import {HttpClientProjectApi} from '@/services/ProjectApi/ProjectApiHttpClient';
import {ClickerStateMocks} from '@/services/ProjectApi/mocks/ClickerStateMocks';
import {ProjectDate} from '@/services/ProjectDate/ProjectDate';
import {QueryStringService} from '@/services/QueryStringService/QueryStringService';
import {ScrollService} from '@/services/ScrollService/ScrollService';
import {TracingService} from '@/services/TracingService/TracingService';
import {TrackingService} from '@/services/TrackingService/TrackingService';
import {DailyGameService} from '@/services/shared/DailyGameService/DailyGameService';
import {GameOperationsService} from '@/services/shared/GameOperationsService/GameOperationsService';
import {ImprovementsMapService} from '@/services/shared/ImprovementsMapService/ImprovementsMapService';
import {InitializeService} from '@/services/shared/InitializeService/InitializeService';
import {TasksService} from '@/services/shared/TasksService/TasksService';
import {Config} from '@/types';
import {ApiRoutes, ClientRoutes, Envs, GlobalWindow} from '@/types';
import {CallbackCollector} from '@/utils/CallbackCollector';
import {Vibration} from '@/utils/Vibration';
import {PseudoRandom} from '@/utils/random/PseudoRandom';
import {RealRandom} from '@/utils/random/RealRandom';

export const INFRA_TOKENS = {
  httpClientProjectApi: token<HttpClientProjectApi>('httpClientProjectApi'),
  resources: token<ResourcesAll>('resources'),
  envs: token<Envs>('envs'),
  config: token<Config>('config'),
  clientRoutes: token<ClientRoutes>('clientRoutes'),
  apiRoutes: token<ApiRoutes>('apiRoutes'),
  loggerService: token<LoggerService>('loggerService'),
  trackingService: token<TrackingService>('trackingService'),
  localStorageService: token<RealStorage | NullStorage>('localStorageService'),
  queryStringService: token<QueryStringService>('queryStringService'),
  platformService: token<PlatformService>('platformService'),
  errorsService: token<ErrorsService>('errorsService'),
  scrollService: token<ScrollService>('scrollService'),
  navigationService: token<NavigationService>('navigationService'),
  navigationClickerModalService: token<NavigationClickerModalService>('navigationClickerModalService'),
  initializeService: token<InitializeService>('initializeService'),
  dailyGameService: token<DailyGameService>('dailyGameService'),
  dailyGameMocks: token<DailyGameMocks>('dailyGameMocks'),
  clickerStateMocks: token<ClickerStateMocks>('clickerStateMocks'),
  leaderBoardMocks: token<LeaderBoardMocks>('leaderBoardMocks'),
  gameStatusMocks: token<GameStatusMocks>('gameStatusMocks'),
  gameOperationsService: token<GameOperationsService>('gameOperationsService'),
  tasksService: token<TasksService>('tasksService'),
  tasksMocks: token<TasksMocks>('tasksMocks'),
  globalWindow: token<GlobalWindow>('globalWindow'),
  sentryBrowser: token<SentryBrowserAbstract>('sentryBrowser'),
  realRandom: token<RealRandom>('realRandom'),
  pseudoRandom: token<PseudoRandom>('pseudoRandom'),
  callbackCollector: token<CallbackCollector>('callbackCollector'),
  cookieStorage: token<CookieStorage>('cookieStorage'),
  tracingService: token<TracingService>('tracingService'),
  devtoolsMbService: token<DevToolsMbService>('devtoolsMbService'),
  improvementsMapService: token<ImprovementsMapService>('improvementsMapService'),
  mediaService: token<MediaService>('mediaService'),
  rewardsAnimationsService: token<RewardsAnimationsService>('rewardsAnimationsService'),
  eventEmitter: token<EventEmitter>('eventEmitter'),
  vibration: token<Vibration>('vibration'),
  clickerIncomeUpdater: token<ClickerIncomeUpdater>('clickerIncomeUpdater'),
  projectDate: token<ProjectDate>('projectDate'),
};
